import {
	HomeEnum,
	TelehealthBookingEnum,
	FacialBiometricEnum,
	MyAppointmentsEnum,
} from 'presentation/constants';
import {useMediaQueries} from 'presentation/pages/private';
import {translations} from 'presentation/translations-new';
import {useNavigate, useLocation} from 'react-router-dom';
import {useCurrentStepStore, useDivergentAttemptsStore, useFacePhotoStore} from '../../../store';

import {BIOMETRIC_STEPS} from '../../../constants';
import {useFacialBiometricsStore} from 'presentation/modules/booking/shared/store/useFacialBiometricsStore';

const {confirmAppointment, goToAppointments} = translations['pt-br'].others.facialBiometric.success;

export function useSuccessPage() {
	const {isTablet} = useMediaQueries();
	const navigate = useNavigate();
	const {search} = useLocation();

	const {reset: resetStep} = useCurrentStepStore();
	const resetAttempts = useDivergentAttemptsStore(state => state.reset);
	const resetFacePhotos = useFacePhotoStore(state => state.reset);
	const {isTea, guardians} = useFacialBiometricsStore(state => state);

	const showRegisterAnotherGuardian =
		isTea && guardians.some(guardian => !guardian.facialRegistered);

	function handleGoToHome() {
		navigate(HomeEnum.HOME_PAGE);
	}

	function handleGo() {
		if (search) {
			navigate(TelehealthBookingEnum.TELEHEALTH_BOOKING_FLOW, {
				state: {from: FacialBiometricEnum.FACIAL_BIOMETRIC},
			});

			return;
		}
		navigate(MyAppointmentsEnum.MY_APPOINTMENTS);
	}

	function handleRegisterAnotherGuardian() {
		resetStep();
		resetAttempts();
		resetFacePhotos();
		navigate({pathname: BIOMETRIC_STEPS[0], search});
	}

	const getPrimaryAction = () => {
		if (!search) {
			return goToAppointments;
		}

		return confirmAppointment;
	};

	const primaryAction = getPrimaryAction();

	return {
		isTablet,
		handleGoToHome,
		handleGo,
		handleRegisterAnotherGuardian,
		primaryAction,
		showSecondaryAction: !search,
		showRegisterAnotherGuardian,
	};
}
